export const answeringServiceTypesFilters = [
  { text: 'On', value: 'on' },
  { text: 'N/S', value: 'ns' },
  { text: 'Live Concierge Plus', value: 'LiveConciergePlus' },
  { text: 'Appt Desk Only', value: 'AppointmentDesk' },
];
